import emptySliceApi from '../../../../../shared/store/emptyApiSlice';
import { InternalAdminModel } from '../models';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    removeInternalAdmin: builder.mutation<InternalAdminModel, { id: number }>({
      query: ({ id }) => ({
        url: `v4/poweradmins/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Admin'],
    }),
    removeInternalAdminInvite: builder.mutation<
      InternalAdminModel,
      { inviteId: string }
    >({
      query: ({ inviteId }) => ({
        url: `v4/poweradmins/invite/${inviteId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Admin'],
    }),
  }),
});

export const {
  useRemoveInternalAdminMutation,
  useRemoveInternalAdminInviteMutation,
} = apiSlice;
